import { memo, type FC } from 'react';
import { StyleSheet } from 'react-native';

import type { GenericPostDetailProps } from '@/features/posts/components/detail/GenericPostDetailView';
import { PostCard } from '@/features/posts/components/feed/PostCard';
import { PostCardCompactBadge } from '@/features/posts/components/feed/PostCardCompactBadge';
import { PostCardCompactBody } from '@/features/posts/components/feed/PostCardCompactBody';
import { PostCardCompactThumbnail } from '@/features/posts/components/feed/PostCardCompactThumbnail';
import { PostProvider } from '@/features/posts/components/feed/PostCardContext';
import { Stack } from '@/shared/components/layout/Stack';

const styles = StyleSheet.create({
  card: { marginBottom: 0 },
  inner: { paddingVertical: 0, paddingHorizontal: 0 },
  body: { padding: 12 }
});

export const PostScreenCompactCard: FC<{ post: GenericPostDetailProps }> = memo(
  ({ post }) => (
    <PostProvider value={post}>
      <PostCard cardStyle={styles.card} cardInnerStyle={styles.inner} flat>
        <PostCard.Content>
          <Stack>
            <PostCardCompactThumbnail />
            <PostCardCompactBadge />
          </Stack>
          <PostCardCompactBody style={styles.body} />
        </PostCard.Content>
      </PostCard>
    </PostProvider>
  )
);
PostScreenCompactCard.displayName = 'PostScreenCompactCard';
